let formMembershipValidator = null;
let lang;
const formMembershipInitValidator = function() {
    if (formMembershipValidator == null) {
        if ($('#form-membership').length) {
            lang = 'EN';
        } else if ($('#form-membership-es').length) {
            lang = 'ES';
        }
        if ('EN' == lang) {
            formMembershipValidator = $('#form-membership').validate({
                rules: {
                    membership_name: {
                        required: true
                    },
                    membership_nie: {
                        required: true
                    },
                    membership_nationality: {
                        required: true
                    },
                    membership_address: {
                        required: true
                    },
                    membership_email: {
                        required: true,
                        email: true
                    },
                    membership_phone: {
                        required: true
                    },
                    membership_type: {
                        required: true
                    },
                    membership_accept: {
                        required: true
                    }
                },
                messages: {
                    membership_name: {
                        required: 'Write your name, please'
                    },
                    membership_nie: {
                        required: 'Write your D.N.I / N.I.E / Passport, please'
                    },
                    membership_nationality: {
                        required: 'Write your nationality, please'
                    },
                    membership_address: {
                        required: 'Write your address, please'
                    },
                    membership_email: {
                        required: 'Write your email, please',
                        email: 'The email is not correct'
                    },
                    membership_phone: {
                        required: 'Write your phone number, please'
                    },
                    membership_type: {
                        required: 'Select an option, please'
                    },
                    membership_accept: {
                        required: 'It is necessary to read and accept the legal notice'
                    }
                },
                errorElement: 'span',
                errorClass: 'error',
                errorPlacement: function (error, element) {
                    error.insertAfter(element);
                },
                success: function (label, element) {
                    if ($(element).next('span')[0])
                        $(element).next('span')[0].remove();
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').addClass('alert').addClass('alert-danger');
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').removeClass('alert').removeClass('alert-danger');
                }
            });
        } else if ('ES' == lang) {
            formMembershipValidator = $('#form-membership-es').validate({
                rules: {
                    membership_name: {
                        required: true
                    },
                    membership_nie: {
                        required: true
                    },
                    membership_nationality: {
                        required: true
                    },
                    membership_address: {
                        required: true
                    },
                    membership_email: {
                        required: true,
                        email: true
                    },
                    membership_phone: {
                        required: true
                    },
                    membership_type: {
                        required: true
                    },
                    membership_accept: {
                        required: true
                    }
                },
                messages: {
                    membership_name: {
                        required: 'Escriba su nombre, por favor'
                    },
                    membership_nie: {
                        required: 'Escriba su D.N.I / N.I.E / Pasaporte, por favor'
                    },
                    membership_nationality: {
                        required: 'Escriba su nacionalidad, por favor'
                    },
                    membership_address: {
                        required: 'Escriba su dirección, por favor'
                    },
                    membership_email: {
                        required: 'Escriba su email, por favor',
                        email: 'El email no es correcto'
                    },
                    membership_phone: {
                        required: 'Escriba su número de teléfono, por favor'
                    },
                    membership_type: {
                        required: 'Selecciona una opción, por favor'
                    },
                    membership_accept: {
                        required: 'Es necesario leer y aceptar el  aviso legal'
                    }
                },
                errorElement: 'span',
                errorClass: 'error',
                errorPlacement: function (error, element) {
                    error.insertAfter(element);
                },
                success: function (label, element) {
                    if ($(element).next('span')[0])
                        $(element).next('span')[0].remove();
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').addClass('alert').addClass('alert-danger');
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').removeClass('alert').removeClass('alert-danger');
                }
            });
        }
    }
};
const formMembershipPay = function() {
    formMembershipInitValidator();
    if ('EN' == lang) {
        if (!$('#form-membership').valid()) {
            return false;
        }
    } else if ('ES' == lang) {
        if (!$('#form-membership-es').valid()) {
            return false;
        }
    }
    $('#membership_name').prop("disabled", true);
    $('#membership_nie').prop("disabled", true);
    $('#membership_nationality').prop("disabled", true);
    $('#membership_address').prop("disabled", true);
    $('#membership_email').prop("disabled", true);
    $('#membership_phone').prop("disabled", true);
    $('#membership_type').prop("disabled", true);
    $('#membership_partner').prop("disabled", true);
    $('#btn-membership-pay').addClass('d-none');
    $('#form-membership-pay').removeClass('d-none');
}

let formMembershipCardValidatorInitialized = false;

const formMembershipCardInitValidator = function() {
    if (!formMembershipCardValidatorInitialized) {
        if ($('#form-membership').length) {
            lang = 'EN';
        } else if ($('#form-membership-es').length) {
            lang = 'ES';
        }
        formMembershipCardValidatorInitialized = true;
        if ('EN' == lang) {
            $('#membership_cardtype').rules('add', {
                required: true,
                messages: {
                    required: 'Select the type of card, please'
                }
            });
            $('#membership_cardnumber').rules('add', {
                required: true,
                messages: {
                    required: 'Write the card number, please'
                }
            });
            $('#membership_cardcode').rules('add', {
                required: true,
                messages: {
                    required: 'Write the security code, please'
                }
            });
            $('#membership_cardexpiration').rules('add', {
                required: true,
                messages: {
                    required: 'Write the expiration date, please'
                }
            });
            $('#membership_cardname').rules('add', {
                required: true,
                messages: {
                    required: 'Write your name on card, please'
                }
            });
            $('#membership_cardaccept').rules('add', {
                required: true,
                messages: {
                    required: 'It is necessary to read and accept the legal notice'
                }
            });
        } else if ('ES' == lang) {
            $('#membership_cardtype').rules('add', {
                required: true,
                messages: {
                    required: 'Seleccione el tipo de tarjeta, por favor'
                }
            });
            $('#membership_cardnumber').rules('add', {
                required: true,
                messages: {
                    required: 'Escriba el número de la tarjeta, por favor'
                }
            });
            $('#membership_cardcode').rules('add', {
                required: true,
                messages: {
                    required: 'Escriba el código de seguridad, por favor'
                }
            });
            $('#membership_cardexpiration').rules('add', {
                required: true,
                messages: {
                    required: 'Escriba la fecha de caducidad, por favor'
                }
            });
            $('#membership_cardname').rules('add', {
                required: true,
                messages: {
                    required: 'Escriba su nombre que aparece en la tarjeta, por favor'
                }
            });
            $('#membership_cardaccept').rules('add', {
                required: true,
                messages: {
                    required: 'Es necesario leer y aceptar el aviso legal'
                }
            });
        }
    }
};
const formMembershipSend = function() {
    $('#membership-success').addClass('d-none');
    $('#membership-error').addClass('d-none');
    formMembershipCardInitValidator();
    let url;
    if ('EN' == lang) {
        if (!$('#form-membership').valid()) {
            return false;
        }
        url = '/api/formulario/membership';
    } else if ('ES' == lang) {
        if (!$('#form-membership-es').valid()) {
            return false;
        }
        url = '/api/formulario/es/membership';
    }
    $('#btn-membership-send').addClass('d-none');
    $('#btn-membership-sending').removeClass('d-none');
    const payload = {
        name: $('#membership_name').val(),
        nie: $('#membership_nie').val(),
        nationality: $('#membership_nationality').val(),
        address: $('#membership_address').val(),
        email: $('#membership_email').val(),
        phone: $('#membership_phone').val(),
        type: $('#membership_type').val(),
        partner: $('#membership_partner').val(),
        comercial: $('#membership_comercial').val(),
        acceptinformation: $('#membership_accept').prop('checked'),
        cardtype: $('#membership_cardtype').val(),
        cardnumber: $('#membership_cardnumber').val(),
        cardcode: $('#membership_cardcode').val(),
        cardexpiration: $('#membership_cardexpiration').val(),
        cardname: $('#membership_cardname').val(),
        subject: 'Helicópteros Sanitarios: formulario "become a member online"'
    };
    $.ajax({
        headers: {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json; charset=utf-8'
        },
        type: 'POST',
        url: url,
        data: JSON.stringify(payload),
        dataType: 'json',
        success: function (data, status, jqXHR) {
            $('#btn-membership-send').removeClass('d-none');
            $('#btn-membership-sending').addClass('d-none');
            if ('OK' == data.status) {
                $('#membership_cardtype,#membership_cardnumber,#membership_cardcode,#membership_cardexpiration,#membership_cardname').val('');
                //$('#membership-success').html(data.message).removeClass('d-none');
                if ('EN' == lang) {
                    document.location.href = './thanks.html';
                } else if ('ES' == lang) {
                    document.location.href = './gracias.html';
                }
            } else {
                $('#membership-error').html(data.message).removeClass('d-none');
            }
        },
        error: function (jqXHR, status) {
            $('#btn-membership-send').removeClass('d-none');
            $('#btn-membership-sending').addClass('d-none');
            if ('EN' == lang)
                $('#membership-error').html('Your message has not been delivered, please try again.<br />If the problem persists please contact us at: info@helicopterossanitarios.com<br />Sorry for the inconvenience.').removeClass('d-none');
            else if ('ES' == lang)
                $('#membership-error').html('Su mensaje no ha podido ser entregado, por favor inténtelo más tarde.<br />Si el problema persiste, póngase en contacto con nosotros en: info@helicopterossanitarios.com<br />Disculpe las molestias.').removeClass('d-none');
        }
    });
    return false;
};

window.formMembershipPay = formMembershipPay;
window.formMembershipSend = formMembershipSend;

$(document).ready(function() {
    if ($.contains(document.body, document.getElementById('form-item-commercial'))) {
        const urlParams = new URLSearchParams(location.search);
        if (urlParams.has('comercial') && 'on' == urlParams.get('comercial')) {
           $('#form-item-commercial').removeClass('d-none');
        }
    }
});